import { render, staticRenderFns } from "./TenantsMenuList.vue?vue&type=template&id=04a9225e&"
import script from "./TenantsMenuList.vue?vue&type=script&lang=js&"
export * from "./TenantsMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports